import { call, put, take, select } from 'redux-saga/effects'
import { eventChannel }    from 'redux-saga'
import PopularActions      from '../reducers/popularReducer'
import firebase            from '../config/firebase'

export function* getPopularList() {
  const { region } = yield select(state => state.auth.data)
  const database = firebase.database()
  const sponsorsConnectionRef = database.ref('/popular_list').orderByChild('region').equalTo(region)
  const databaseEventChannel = yield call(observerEvent, sponsorsConnectionRef) // listening databaseEvent

  try {
    while (true) {
      const list = yield take(databaseEventChannel) // take event data

      yield put(PopularActions.getPopularListConnected(list))
    }
  } catch(error) {
      yield put(PopularActions.getPopularListError(error))
  } finally {
    databaseEventChannel.close();
  }
}

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        let newObj = {}
        data.forEach((res) => { newObj[res.key] = res.val() })
        emit(newObj)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  });

  return listener
};


// WEBPACK FOOTER //
// ./src/sagas/popularSaga.js